import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import MultiChoices from './MultiChoices';
import MultiInputs from './MultiInputs';
import DropContents from './DropContents';
import MultiInputInPra from './MultiInputInPra';
import MultiInputsInImage from './MultiInputsInImage';
import TableInputs from './TableInputs';
import TextArea from './TextArea';
import TextInput from './TextInput';

class Answers extends Component {

  renderAnswerContent() {
    if (this.props.answers.type === 'table inputs two') {
      return (
        <div className={this.props.answers.className}>
          <TableInputs
            key='1'
            content={this.props.answers.content}
            answersIndex={this.props.answers.answersIndex}
            toggleQuestion={this.props.toggleQuestion}
            chosenQuestionId={this.props.chosenQuestion}
            checkAnsweredQuestion={this.props.checkAnsweredQuestion}
            storeAnswers={this.props.storeAnswers}
            storedAnswers={this.props.storedAnswers}
          />

          <div  className='static-table-container'>
            <table>
              <tbody>
                <tr><td colSpan="2"><p><strong><span>List of political units<br /></span></strong></p></td></tr>
                <tr><td><p><strong>A</strong></p></td>
                  <td><p>Tichitt-Oualata</p></td>
                </tr>
                <tr><td><p><strong>B</strong></p></td>
                  <td><p>Jenné-Jeno</p></td>
                </tr>
                <tr><td><p><strong>C</strong></p></td>
                  <td><p>Igbo-Ukwu</p></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )
    } else if (this.props.answers.type === 'table inputs') {
      return (
        <div className={this.props.answers.className}>
          <TableInputs
            key='2'
            content={this.props.answers.content}
            answersIndex={this.props.answers.answersIndex}
            toggleQuestion={this.props.toggleQuestion}
            chosenQuestionId={this.props.chosenQuestion}
            checkAnsweredQuestion={this.props.checkAnsweredQuestion}
            storeAnswers={this.props.storeAnswers}
            storedAnswers={this.props.storedAnswers}
          />
        </div>
      )
    } else if (this.props.answers.type === 'radios') {
      return (
        <MultiChoices
          content={this.props.answers.content}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          answerType='one answer'
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'checkboxes') {
      return (
        <MultiChoices
          content={this.props.answers.content}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          answerType='two answers'
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'inputTexts in paragraphs') {
      return (
        <MultiInputs
          content={this.props.answers.content}
          number={this.props.answers.number}
          className={this.props.answers.className}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'dragNDrop') {
      return (
        <DropContents
          content={this.props.answers.content}
          number={this.props.answers.number}
          className={this.props.answers.className}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          dragItems={this.props.answers.dragItems}
          generateReplacedText={this.props.generateReplacedText}
          replacedText={this.props.replacedText}
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'inputTexts in one ul') {
      return (
        <div className={`multiple-inputs-container ${this.props.answers.className}`}>
            {this.props.answers.content.map((c) =>
              <div key={c.id}>
                {ReactHtmlParser(c.answers[0])}
                <TextInput
                  id={c.id}
                  toggleQuestion={this.props.toggleQuestion}
                  chosenQuestionId={this.props.chosenQuestion}
                  checkAnsweredQuestion={this.props.checkAnsweredQuestion}
                  storeAnswers={this.props.storeAnswers}
                  storedAnswers={this.props.storedAnswers}
                />
                {ReactHtmlParser(c.answers[1])}
              </div>
            )}
        </div>
      )
    } else if (this.props.answers.type === 'inputTexts in one paragraph') {
      return (
        <MultiInputInPra
          content={this.props.answers.content}
          number={this.props.answers.number}
          className={this.props.answers.className}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'inputTexts in an image') {
      return (
        <MultiInputsInImage
          content={this.props.answers.content}
          number={this.props.answers.number}
          className={this.props.answers.className}
          toggleQuestion={this.props.toggleQuestion}
          chosenQuestionId={this.props.chosenQuestion}
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else if (this.props.answers.type === 'writing') {
      return (
        <TextArea
          checkAnsweredQuestion={this.props.checkAnsweredQuestion}
          writingAnswerNote={this.props.writingAnswerNote}
          updateAnwerPerPage={this.props.updateAnwerPerPage}
          pageNumber={this.props.pageNumber}
          storeAnswers={this.props.storeAnswers}
          storedAnswers={this.props.storedAnswers}
        />
      )
    } else {
      return (
        <div>{ReactHtmlParser(this.props.answers.content)}</div>
      )
    }
  }

  render() {
    const { question, description, title } = this.props.answers;
    return (
      <div>
        {question && <h4>{question}</h4>}
        {description && <p>{ReactHtmlParser(description)}</p>}
        {title && <h3>{title}</h3>}
        {this.renderAnswerContent()}
      </div>
    );
  }
}

export default Answers;
